import toEnglishDigits from './toEnglishDigits';

const CheckNumericType = (value) => {
  return /^-?\d+$/.test(value);
};
export default CheckNumericType;
